export const getWebinarsIsFetching = state => state.webinarsReducer.isFetching;
export const getWebinarsError = state => state.webinarsReducer.error;

export const getWebinars = state => state.webinarsReducer.webinars;
